import { Controller } from "@hotwired/stimulus"
import {debounce} from "../libs/utils";

/**
 * Make forms to submit when a new change is made in one of its inputs
 *
 * @example
 * <form data-controller="autosubmit">
 *   <input />
 * </form>
 */

export default class SortButtonController extends Controller {
  static values = {
    formId: String,
    column: String,
    direction: String,
  }

  initialize() {
    if (this.form == null) {
      console.error("SortButtonController: form not found");
      console.error("SortButtonController: here", this.element);
    }
  }

  get form() {
    return document.querySelector("#" + this.formIdValue);
  }

  sort() {
    if (this.form == null) {
      return;
    }

    // const column = document.createElement('input');
    // column.setAttribute('type', 'hidden');
    // column.setAttribute('name', 'sorting[column]');

    const column = this.findOrCreateInputByName('sorting[column]');
    column.value = this.columnValue;

    // const direction = document.createElement('input');
    // direction.setAttribute('type', 'hidden');
    // direction.setAttribute('name', 'sorting[direction]');

    const direction = this.findOrCreateInputByName('sorting[direction]');
    direction.value = this.directionValue;

    this.form.insertAdjacentElement('beforeend', column);
    this.form.insertAdjacentElement('beforeend', direction);

    console.log("sort", this.form);
    this.element.setAttribute('disabled', 'disabled');

    this.form.requestSubmit();
  }

  findOrCreateInputByName(name) {
    let input = this.form.querySelector(`input[name="${name}`);

    if (input == null) {
      input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', name);
      this.form.insertAdjacentElement('beforeend', input);
    }

    return input;
  }
}
